import { render, staticRenderFns } from "./DialogTaskWithCustomer.vue?vue&type=template&id=82cade68"
import script from "./DialogTaskWithCustomer.vue?vue&type=script&lang=js"
export * from "./DialogTaskWithCustomer.vue?vue&type=script&lang=js"
import style0 from "./DialogTaskWithCustomer.vue?vue&type=style&index=0&id=82cade68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports